import { useToastStore } from '../../../lib/toast-store';

const COLD_TOAST_ID = 'world-bootstrap';
const WARM_TOAST_ID = 'world-revalidate';

const COLD_STAGES = {
  checking:   { progress: 10, message: 'Verifying your workspace…' },
  authRetry:  { progress: 20, message: 'Finalizing sign-in…' },
  import:     { progress: 35, message: 'Syncing OpenClaw agents…' },
  importSlow: { progress: 55, message: 'Still syncing OpenClaw agents…' },
  bootstrap:  { progress: 80, message: 'Loading world state…' },
  ready:      { progress: 100, message: 'Workspace ready' },
};

function store() {
  return useToastStore.getState();
}

export function beginColdBootstrapToast() {
  const { progress, message } = COLD_STAGES.checking;
  store().showToast({ id: COLD_TOAST_ID, message, progress });
}

export function updateColdBootstrapToast(stage) {
  const preset = COLD_STAGES[stage];
  if (!preset) return;
  store().updateToast(COLD_TOAST_ID, preset);
}

export function finishColdBootstrapToast() {
  const { progress, message } = COLD_STAGES.ready;
  store().updateToast(COLD_TOAST_ID, { progress, message });
}

export function dismissColdBootstrapToast() {
  store().dismissToast(COLD_TOAST_ID);
}

export function errorColdBootstrapToast(detail) {
  store().dismissToast(COLD_TOAST_ID);
  store().showToast({
    id: COLD_TOAST_ID,
    message: detail || "Couldn't connect — refresh to retry",
    variant: 'error',
  });
}

const REVALIDATE_QUIET_MS = 500;

export function beginRevalidateToast() {
  const startedAt = Date.now();
  let shown = false;
  let settled = false;

  const showIfStillRunning = () => {
    if (settled || shown) return;
    shown = true;
    store().showToast({
      id: WARM_TOAST_ID,
      message: 'Syncing with OpenClaw…',
      progress: 40,
    });
  };

  const timer = typeof window !== 'undefined'
    ? window.setTimeout(showIfStillRunning, REVALIDATE_QUIET_MS)
    : null;

  const clearTimer = () => {
    if (timer !== null && typeof window !== 'undefined') {
      window.clearTimeout(timer);
    }
  };

  return {
    /** Call when revalidate succeeds AND returned state differed from cached. */
    successChanged: () => {
      if (settled) return;
      settled = true;
      clearTimer();
      shown = true;
      store().showToast({
        id: WARM_TOAST_ID,
        message: 'Workspace updated',
        progress: 100,
      });
    },
    /** Call when revalidate succeeds AND returned state matched cache. */
    successUnchanged: () => {
      if (settled) return;
      settled = true;
      clearTimer();
      const elapsed = Date.now() - startedAt;
      if (!shown && elapsed < REVALIDATE_QUIET_MS) {
        // Never showed; skip entirely.
        return;
      }
      // Already visible or slow enough to warrant closure — show "up to date".
      store().showToast({
        id: WARM_TOAST_ID,
        message: 'Up to date',
        progress: 100,
      });
    },
    /** Call on error. */
    error: (detail) => {
      if (settled) return;
      settled = true;
      clearTimer();
      store().dismissToast(WARM_TOAST_ID);
      store().showToast({
        id: WARM_TOAST_ID,
        message: detail || 'Offline — showing cached state',
        variant: 'error',
      });
    },
  };
}
